import React from 'react';

const TimelineStatusIcon = ({fill = 'grey'}) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 10 18"
      xmlSpace="preserve"
      className="card-icon"
    >
      <title>Status Update</title>
      <desc>Created with Sketch.</desc>
      <g id="Case-Details---New">
        <g id="Case-Details---Timeline" transform="translate(-865.000000, -2234.000000)">
          <g id="Timeline" transform="translate(255.000000, 777.000000)">
            <g id="Timeline-Items" transform="translate(277.000000, 107.000000)">
              <g id="Status-Changed" transform="translate(317.000000, 1334.000000)">
                <g id="Icon">
                  <g id="Avatar">
                    <path
                      id="Shape"
                      fill={fill}
                      d="M23.2,29.5c0,1.1-1,2-2.2,2c-1.2,0-2.2-0.9-2.2-2c0-0.8,0.5-1.5,1.3-1.8v-4.1
                      c0-0.5,0.4-0.8,0.9-0.8c0.5,0,0.9,0.4,0.9,0.8v4.1C22.7,28,23.2,28.7,23.2,29.5z M24.8,26.5c0.8,0.8,1.3,1.8,1.3,3
                      c0,2.5-2.2,4.5-5,4.5c0,0,0,0,0,0c-2.7,0-5-2.1-5-4.5c0-1.1,0.5-2.2,1.2-3v-7.1c0-1.9,1.7-3.4,3.8-3.4c2.1,0,3.7,1.5,3.7,3.4
                      V26.5z M24.4,29.5c0-1.3-0.8-2-1.3-2.4v-7.7c0-1.1-1-2-2.2-2c-1.2,0-2.2,0.9-2.2,2v7.7c-0.4,0.4-1.2,1.1-1.2,2.4
                      c0,1.7,1.5,3.1,3.4,3.1l0,0C22.9,32.6,24.4,31.2,24.4,29.5z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default TimelineStatusIcon;
